import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SipPitchCardV2Component } from './sip-pitch-card-v2.component';
import { PaymentSipDialogBtnModule } from '../payment-sip-dialog-btn/payment-sip-dialog-btn.module';
import { OfferNoteModule } from '../offer-note/offer-note.module';
import { SharedModule } from '../../shared/shared.module';
import { PaymentSipDonorsModule } from '../payment-sip-donors/payment-sip-donors.module';



@NgModule({
  declarations: [
    SipPitchCardV2Component
  ],
  exports: [
    SipPitchCardV2Component
  ],
  imports: [
    CommonModule,
    PaymentSipDialogBtnModule,
    OfferNoteModule,
    SharedModule,
    PaymentSipDonorsModule
  ]
})
export class SipPitchCardV2Module { }
